import { useTranslation } from 'react-i18next'

import { MenuOpenIcon } from '@pleio/icons/menu-open'

import { closeDrawer, Drawer } from 'js/components/Drawer'
import HeaderBar from 'js/components/HeaderBar/HeaderBar'
import Menu from 'js/components/MobileNavigationMenu/MobileNavigationMenu'
import { Show } from 'js/components/Show'
import NavigationAction from 'js/layout/Navigation/components/NavigationAction'

import styles from './MobileNavigation.module.css'
import MobileNavigationSearch from './MobileNavigationSearch'

export const MOBILE_NAVIGATION_ID = 'menu-mobile'

// only for header so move it up to Header as component, now it looks generic layout component while really being specific
const MobileNavigation = ({ site }) => {
    const { t } = useTranslation()

    return (
        <Drawer id={MOBILE_NAVIGATION_ID} aria-label={t('admin.menu')}>
            <div className={styles.navigation}>
                <HeaderBar>
                    <div className={styles.header}>
                        <NavigationAction
                            tooltip={t('action.hide-navigation')}
                            onClick={() => closeDrawer(MOBILE_NAVIGATION_ID)}
                            style={
                                site?.menuState === 'compact'
                                    ? { marginLeft: 'calc(100% - 220px)' }
                                    : { marginLeft: '-8px' }
                            }
                        >
                            <MenuOpenIcon />
                        </NavigationAction>
                    </div>
                </HeaderBar>
                <div className={styles.content}>
                    <Show until="mobileLandscape">
                        <MobileNavigationSearch />
                    </Show>
                    <Menu site={site} />
                </div>
            </div>
        </Drawer>
    )
}

export default MobileNavigation
